export default function withLeadingZero(n: number) {
  const str = n.toString();
  return str.length === 1 ? `0${str}` : str;
}
